
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/scientific-diagram-maker",
      function () {
        return require("private-next-pages/scientific-diagram-maker.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/scientific-diagram-maker"])
      });
    }
  